import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersActiveConversation {
  @service messaging;
  @service messagingNavigation;

  constructor(owner) {
    setOwner(this, owner);
  }

  handleActivity(_response) {
    const handler = this.messagingNavigation.currentConversationHandler;
    const conversation = handler?.conversation;

    if (!conversation) {
      return;
    }

    handler.fetchAndValidateUsers.perform(conversation);
  }
}
